<template>
    <div class="tw-bg-white tw-border tw-border-solid tw-border-gray-200 tw-px-4 tw-py-2 tw-rounded tw-h-full">
        <p class="tw-font-bold tw-text-lg">Performance</p>


    </div>
</template>

<script setup>

</script>